import { Link } from '@chakra-ui/react';
import { useIngestionFolderPlatformUrlQuery } from '@client/graphql/__generated__/document-operations';
import { useExternalIngestionFolderPlatformUrlQuery } from '@client/graphql/__generated__/main-operations';
import { ExternalIngestionFolderFragment } from '@client/graphql/__generated__/types';
import { FC, memo } from 'react';
import { formatPlatformName } from './utils/platform.utils';

interface CompliancePlatformLinkButtonProps {
  variant: 'internal' | 'external';
  ingestionFolder: ExternalIngestionFolderFragment;
}

export const CompliancePlatformLinkButton: FC<CompliancePlatformLinkButtonProps> =
  memo(function CompliancePlatformLinkButton({ ingestionFolder, variant }) {
    const { data: externalData } = useExternalIngestionFolderPlatformUrlQuery({
      variables: {
        input: {
          ingestionFolderId: ingestionFolder.id,
        },
      },
      skip: variant === 'internal',
    });

    const { data: internalData } = useIngestionFolderPlatformUrlQuery({
      variables: {
        ingestionFolderId: ingestionFolder.id,
      },
      skip: variant !== 'internal',
    });

    // [NOTE] Make sure we strictly follow the variant
    const platformLink =
      variant === 'external'
        ? externalData?.externalIngestionFolderPlatformUrl
        : variant === 'internal'
          ? internalData?.ingestionFolderPlatformUrl
          : null;

    if (!platformLink) {
      return null;
    }

    return (
      <Link
        isExternal
        color="compliance.text.secondary"
        fontSize="sm"
        href={platformLink}
        textDecoration="underline"
      >
        Open in {formatPlatformName(ingestionFolder.platform)}
      </Link>
    );
  });
